(function () {
  function initHowToSteps(section) {
    if (!section || section.dataset.mHowToStepsInit === 'true') return;

    section.dataset.mHowToStepsInit = 'true';

    const revealItems = section.querySelectorAll('.m-how-to-steps__reveal');
    const left = section.querySelector('.m-how-to-steps__left');
    const leftInner = section.querySelector('.m-how-to-steps__left-inner');
    const leftContent = section.querySelector('.m-how-to-steps__left-content');
    const right = section.querySelector('.m-how-to-steps__right');

    function initReveal() {
      if (!revealItems.length) return;

      if (!('IntersectionObserver' in window)) {
        revealItems.forEach(function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    }

    function resetPinnedState() {
      if (!leftInner || !leftContent) return;

      leftInner.style.minHeight = '';
      leftContent.style.width = '';
      leftContent.style.left = '';
      leftContent.classList.remove('is-fixed', 'is-bottom');
    }

    function updatePinnedSticky() {
      if (!left || !leftInner || !leftContent || !right) return;

      if (window.innerWidth <= 989) {
        resetPinnedState();
        return;
      }

      const stickyTop = parseFloat(
        getComputedStyle(section).getPropertyValue('--m-how-to-steps-sticky-top')
      ) || 64;

      const leftRect = left.getBoundingClientRect();
      const rightRect = right.getBoundingClientRect();
      const scrollY = window.pageYOffset || window.scrollY;

      const leftContentHeight = leftContent.offsetHeight;
      const start = leftRect.top + scrollY - stickyTop;
      const end = rightRect.top + scrollY + rightRect.height - leftContentHeight - stickyTop;
      const current = scrollY;

      leftInner.style.minHeight = leftContentHeight + 'px';

      if (current <= start) {
        leftContent.classList.remove('is-fixed', 'is-bottom');
        leftContent.style.width = '';
        leftContent.style.left = '';
        return;
      }

      if (current >= end) {
        leftContent.classList.remove('is-fixed');
        leftContent.classList.add('is-bottom');
        leftContent.style.width = leftRect.width + 'px';
        leftContent.style.left = '0px';
        return;
      }

      leftContent.classList.remove('is-bottom');
      leftContent.classList.add('is-fixed');
      leftContent.style.width = leftRect.width + 'px';
      leftContent.style.left = leftRect.left + 'px';
    }

    let ticking = false;

    function requestStickyUpdate() {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(function () {
        updatePinnedSticky();
        ticking = false;
      });
    }

    initReveal();
    updatePinnedSticky();

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    window.addEventListener('load', requestStickyUpdate);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:reorder', requestStickyUpdate);
      document.addEventListener('shopify:block:select', requestStickyUpdate);
      document.addEventListener('shopify:block:deselect', requestStickyUpdate);
    }
  }

  function initAllHowToSteps() {
    document.querySelectorAll('.m-how-to-steps').forEach(initHowToSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHowToSteps);
  } else {
    initAllHowToSteps();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHowToSteps(event.target);
  });
})();